import React from 'react'
import { Collapse } from 'antd'
import Text from 'antd/es/typography/Text'
import UnitTestsTable from './SubmissionUnitTestResultsTable'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'

const SubmissionUnitTestResultsDetailed = () => {
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)
    const drawer = useSelector(state => state.assignment.drawer)
    const unitTests = useSelector(state => state.assignment.unitTests)
    const unitTestResults = useSelector(state => state.assignment.unitTestResults)
    const layers = useSelector(state => state.assignment.layers)

    let availableCount = 0
    let passedTestsCount = 0
    unitTests.forEach(unitTest => {
        const result = unitTestResults.find(
            unitTestResult => unitTestResult.file_id === openedSubmissionId && unitTestResult.ut_id === unitTest.id,
        )
        if (result !== undefined) {
            availableCount += 1
            if (result.ut_passed) passedTestsCount += 1
        }
    })

    const unitTestsLayerWeight = layers.find(layer => layer.layer_name === 'UnitTests999')?.layer_weight ?? 0
    const unitTestsGradeRounded =
        drawer.file?.ut_grade != null ? Math.round(drawer.file.ut_grade) : null

    return (
        !isNaN(passedTestsCount) &&
        !!unitTests.length && (
            <Collapse ghost bordered={false}>
                <Collapse.Panel
                    header={`Passed ${passedTestsCount}/${availableCount} Unit Tests`}
                    key='unit-tests'
                    extra={
                        unitTestsGradeRounded != null ? (
                            <label>
                                <Text type='secondary' className='mr-8'>
                                    Unit Tests Grade
                                </Text>
                                {unitTestsGradeRounded}/{unitTestsLayerWeight}
                            </label>
                        ) : null
                    }
                >
                    <UnitTestsTable />
                </Collapse.Panel>
            </Collapse>
        )
    )
}

export default SubmissionUnitTestResultsDetailed
